'use client'

import { LayoutContext, useLayoutState } from '@homeSearch/layout/context'
import { HomeSearchContext, useHomeSearchState } from '@homeSearch/modules/context'
import getHouseRoute from '@plugin/searchRoute/modules/house'
import { suburbsToIds } from '@plugin/searchRoute/utils'
import { concat, isEqual } from 'lodash-es'
import { useEffect } from 'react'
import useHouseSearchContext from '../context'
import SearchInputContent from './content'

export default function SearchInput({
  className = ''
}) {

  const { suburbs, isMapArea, toggleIsMapArea, state } = useHouseSearchContext()
  const { slug, surround } = state
  const layoutState = useLayoutState()

  const searchState = useHomeSearchState({
    oneSuburb: false,
    recentSuburb: false,
    searchType: undefined,
    defaultSuburbs: suburbs,
    isMapArea,
    defaultSurrounding: surround
  })
  const { toggleSurrounding } = searchState

  useEffect(() => {
    const houseRoute = getHouseRoute()
    houseRoute.fromSlug(slug)
    toggleSurrounding(houseRoute.surround)
  }, [slug, toggleSurrounding])

  useEffect(() => {
    const houseRoute = getHouseRoute()
    houseRoute.fromSlug(slug)
    const searchSuburbIds = suburbsToIds(searchState.suburbs).idsStr()
    const slugSuburbIds = suburbsToIds(concat(houseRoute.region, houseRoute.district, houseRoute.suburb)).idsStr()
    if (!isEqual(searchSuburbIds, slugSuburbIds)) {
      toggleIsMapArea(false)
    }
  }, [searchState.suburbs, slug, toggleIsMapArea])

  return (
    <HomeSearchContext.Provider value={searchState}>
      <LayoutContext.Provider value={layoutState}>
        <SearchInputContent
          className={className}
          onFocus={() => toggleIsMapArea(false)}
        />
      </LayoutContext.Provider>
    </HomeSearchContext.Provider>
  )
}